module.exports = __webpack_public_path__ + "static/media/overview_data.ba0e2946.svg";